<template>
    <router-view/>
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if(to.name == 'des-motivo-despesa'){
            next({ name: 'des-motivo-despesa-list' })
        }else{
            next()
        }
    },
    created() {
        if(this.$route.name == 'des-motivo-despesa'){
            this.$router.push({ name: 'des-motivo-despesa-list' })
        }
    }
}
</script>
